/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, FormEvent, useState } from "react";
import noop from "lodash/fp/noop";
import { TableColumns, TableRow } from "../../../../../requests/table/types";

import TableDataCellsMobile from "./TableDataCellsMobile";
import { ITableRowControls } from "../../types";
import { ColumnFormatDict } from "../../../../../requests/templates/types";
import { MobileRowLayout } from "../../../ColumnTemplatePositionEditor/types";
import Loader from "../../../../atoms/Loader";
import { ButtonType } from "../../../../../globalTypes";
import EditRowSubmitButtons from "./EditRowSubmitButtons";
import { MobileCellsContainer, tableRowLoaderCss } from "../styles";
import useMobileTableRowEventListeners from "./useMobileTableRowEventListeners";
import { UpdateTableRowCell } from "../../TableDataDesktop/TableDataRow/TableDataRow";

const TableDataRowMobile: FC<TableDataRowMobileProps> = ({
  row,
  columns,
  columnFormatMobileDict,
  positionData,
  allowRowSelection,
  onRowSelect,
  isSelected,
  rowSelectMode,
  onRowClick,
  TableRowMobileControls,
  editMode = false,
  toggleEditMode,
  onEditRowSubmit = noop,
  onEditRowReset = noop,
  updateEditRow,
  isLoading,
  handleSubmit = noop,
  onCellBlur,
}) => {
  const rowEventListeners = useMobileTableRowEventListeners({
    onRowClick,
    rowSelectMode,
    allowRowSelection,
    editMode,
    onRowSelect,
  });

  // opet stejny duvod pouziti tako v TableDataRow.tsx
  const handleSubmitWrapper = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();

    handleSubmit();
  };

  if (!row || isLoading) return <Loader css={tableRowLoaderCss} size={24} />;

  return (
    <MobileCellsContainer
      isSelected={isSelected}
      onSubmit={handleSubmitWrapper}
    >
      {TableRowMobileControls && (
        <TableRowMobileControls
          tableRow={row}
          editMode={editMode}
          toggleEditMode={toggleEditMode}
        />
      )}
      <div {...rowEventListeners}>
        <TableDataCellsMobile
          tableRowData={row}
          columns={columns}
          onCellBlur={onCellBlur}
          columnFormatMobileDict={columnFormatMobileDict}
          positionData={positionData}
          editMode={editMode}
          onCellEdit={updateEditRow}
          variant="table"
        />
      </div>

      {editMode && (
        <EditRowSubmitButtons
          tableRow={row}
          onSubmit={onEditRowSubmit}
          onCancel={onEditRowReset}
          acceptButtonType={ButtonType.Submit}
        />
      )}
    </MobileCellsContainer>
  );
};

type Props = {
  row: TableRow | null;
  columns: TableColumns;
  columnFormatMobileDict: ColumnFormatDict;

  allowRowSelection: boolean;
  rowSelectMode: boolean; // Pokud je aktivní, klik na řádek udělá selekci místo onRowClick
  onRowSelect: () => void;
  isSelected: boolean;

  onRowClick: () => void;

  TableRowMobileControls?: ITableRowControls | null;
  positionData?: MobileRowLayout;

  isLoading?: boolean;
  editMode?: boolean;
  toggleEditMode?: () => void;
  onEditRowSubmit?: () => void;
  onEditRowReset?: () => void;
  updateEditRow?: UpdateTableRowCell;
  onCellBlur?(): void;
  handleSubmit?: () => void;
  setEditableRowSubmit?(): void;
};

export type TableDataRowMobileProps = Props;
export default TableDataRowMobile;
